<template>
  <form name="questionForm" @submit.prevent="sendQuestion">
    <p class="font-weight-bold">Ställ din fråga här:</p>

    <div class="form-group">
      <label for="name">Namn</label>
      <input type="text" name="name" id="name" v-model="questionName" class="form-control">
    </div>

    <div class="form-group">
      <label for="question">Fråga</label>
      <textarea type="text" name="question" id="question" v-model="questionQuestion" class="form-control"></textarea>
    </div>

    <!-- <div class="form-group">
      <vue-recaptcha :sitekey="recaptchaSiteKey" @verify="recaptchaVerified"></vue-recaptcha>
    </div> -->

    <div class="text-success mb-2" v-if="questionThanks">
      {{ questionThanks }}
    </div>
    
    <button type="submit" name="send" id="send" class="btn btn-sm btn-success" :disabled="!this.questionFormValid">Skicka</button>
  </form>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "home",
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        sending: false,
        questionName: null,
        questionQuestion: null,
        questionThanks: null
      }
    },
    computed: {
      questionFormValid() {
        return !this.sending && 
          (this.questionName && this.questionName.length > 0) &&
          (this.questionQuestion && this.questionQuestion.length > 0)
      }
    },
    methods: {
      async sendQuestion() {
        if(!this.questionFormValid) { return false }
        this.sending = true

        await firebase.firestore().collection(`questions`).add({
          name: this.questionName,
          question: this.questionQuestion,
          eventId: this.event.id,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.questionQuestion = null
        this.questionThanks = "Tack för din fråga."
        this.sending = false

        setTimeout(() => { this.questionThanks = null }, 2000)
      }
    },
    async mounted() {

    }
  }
</script>